/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CreditCardTypeEnum {
    NOT_DEFINED = 'NotDefined',
    AMERICAN_EXPRESS = 'AmericanExpress',
    DISCOVER = 'Discover',
    MASTER_CARD = 'MasterCard',
    VISA = 'Visa',
}